<template>
  <div v-if="open">
    <Teleport to="body">
      <div
        v-if="open"
        :class="[
          'modalWrapper fixed left-0 top-0 z-7000! h-full w-screen justify-center overflow-hidden',
        ]"
        :style="{ zIndex }"
      >
        <transition name="wrapper" appear>
          <div
            v-if="open"
            :class="[
              'absolute left-0 top-0 h-full w-screen justify-center bg-neutral-950/70',
            ]"
          >
            <transition :name="'slide'" appear>
              <div
                v-if="open"
                :class="[
                  'relative mx-auto my-8 max-h-[90%] w-[90%] max-w-120 flex-col overflow-auto rounded-md bg-white-500  p-4 md:p-10',
                ]"
              >
                <div class="absolute right-2 top-2 md:right-8 md:top-8">
                  <button
                    @click="closeModal()"
                    class="rounded-full p-2 text-neutral-500 hover:bg-neutral-200 hover:text-neutral-500"
                  >
                    <TIcon name="close" class="h-6 w-6" />
                  </button>
                </div>
                <slot />
              </div>
            </transition>
          </div>
        </transition>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  open: boolean;
}>();

const emits = defineEmits(['close']);

function closeModal() {
  emits('close');
}

const closeEventCb = (e: KeyboardEvent) => {
  if (e.keyCode === 27) {
    closeModal();
  }
};

onMounted(() => {
  document.documentElement.addEventListener('keydown', closeEventCb);
});
onBeforeUnmount(() => {
  document.documentElement.removeEventListener('keydown', closeEventCb);
});

const zIndex = ref(4000);

watch(
  () => props.open,
  (open) => {
    if (open) {
      // traverse the dom for number of modals open
      const modals = document.querySelectorAll('.modalWrapper');
      const numModals = modals.length;
      // set the z-index of the modal to be 4000 + numModals
      zIndex.value = 4000 + numModals;
    }
  },
  { immediate: true },
);
</script>

<style scoped>
.wrapper-enter-active {
  will-change: opacity, transform;
  animation: fade-in 0.2s;
}

.wrapper-leave-active {
  will-change: opacity, transform;
  animation: fade-out 0.2s;
  animation-delay: 0.2s;
}

.slide-enter-active {
  will-change: opacity, transform;
  animation: wait-and-slide-up 0.2s ease-out;
}

.slide-leave-active {
  will-change: opacity, transform;
  animation: slide-down 0.2s ease-out;
}

.slide-leave-active {
  will-change: opacity, transform;
  animation: scale-down 0.2s ease-out;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes slide-down {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(100%);
    opacity: 0;
  }
}

@keyframes wait-and-slide-up {
  0% {
    transform: translateY(50%);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
